/**
 * Sanitizes a `?redirect=` target before it is stored or navigated to.
 *
 * Only same-origin paths are allowed: the result always starts with a single
 * `/`. Protocol-relative (`//evil.com`), external absolute URLs, non-http(s)
 * schemes, backslashes and control characters all fall back to `/`.
 * Same-origin absolute URLs are reduced to their local path so the legacy
 * `location.href` producer keeps working.
 */
function hasUnsafeChars(value: string): boolean {
  for (const char of value) {
    const code = char.codePointAt(0) ?? 0;

    if (code <= 0x1f || code === 0x7f || char === "\\") return true;
  }

  return false;
}

export function safeRedirectPath(raw: string | null | undefined): string {
  if (!raw) return "/";

  if (hasUnsafeChars(raw)) return "/";

  if (!raw.startsWith("/")) {
    let url: URL;

    try {
      url = new URL(raw);
    } catch {
      return "/";
    }

    if (url.protocol !== "http:" && url.protocol !== "https:") return "/";
    const path = `${url.pathname}${url.search}${url.hash}`;

    return path.startsWith("/") && !path.startsWith("//") ? path : "/";
  }

  if (raw.startsWith("//")) return "/";

  return raw;
}
